import { Badge } from "antd";
import { Button } from "@rumbledirect/ui";
import { FilterOutlined } from "@ant-design/icons";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { fetchExpressions } from "@/lib/api/resources/queryExpession";
import { useMemo } from "react";
import { useCurrentUser } from "@/lib/hooks/useCurrentUser";
import { DossierFilterValues } from "@/pages/admin/dossiers/lib/types/DossierFilterValues.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

type DossierFiltersProps = {
  dossiersQuery: UseQueryResult<CollectionResponse<unknown>, Error>;
  filters: Partial<DossierFilterValues>;
  setFilters: (next: Partial<DossierFilterValues>) => void;
};

function DossierFilters({
  dossiersQuery,
  filters,
  setFilters,
}: DossierFiltersProps) {
  const currentUser = useCurrentUser();

  const expressionsQuery = useQuery({
    queryKey: ["expressions"],
    queryFn: () =>
      fetchExpressions({
        source: "dossier-query",
      }),
    select: ({ member }) => member,
    enabled: currentUser?.permissions?.includes("admin_query_expression_read"),
  });

  const permittedExpressions = useMemo(
    () =>
      expressionsQuery.data?.filter(
        ({ permission }) =>
          permission === null ||
          (currentUser?.permissions?.includes(permission) ?? false),
      ) ?? [],
    [expressionsQuery.data, currentUser],
  );
  return (
    <>
      {permittedExpressions.map((expression) => (
        <Badge
          count={
            filters["expression"] === expression.id
              ? dossiersQuery.data?.totalItems
              : 0
          }
          showZero={false}
        >
          <Button
            icon={<FilterOutlined />}
            type={
              filters["expression"] === expression.id ? "primary" : "default"
            }
            onClick={() =>
              setFilters({
                ...filters,
                expression:
                  filters["expression"] === expression.id
                    ? undefined
                    : expression.id,
              })
            }
            loading={dossiersQuery.isLoading}
            variant="light"
          >
            {expression.label}
          </Button>
        </Badge>
      ))}
    </>
  );
}

export default DossierFilters;
